/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateCompanyMemoResponseData,
  CreateCompanyMemoResponseDataFromJSON,
  CreateCompanyMemoResponseDataFromJSONTyped,
  CreateCompanyMemoResponseDataToJSON
} from './CreateCompanyMemoResponseData'

/**
 *
 * @export
 * @interface DiscardCompanyMemoResponse
 */
export interface DiscardCompanyMemoResponse {
  /**
   *
   * @type {number}
   * @memberof DiscardCompanyMemoResponse
   */
  status?: number
  /**
   *
   * @type {CreateCompanyMemoResponseData}
   * @memberof DiscardCompanyMemoResponse
   */
  data?: CreateCompanyMemoResponseData
}

export function DiscardCompanyMemoResponseFromJSON(json: any): DiscardCompanyMemoResponse {
  return DiscardCompanyMemoResponseFromJSONTyped(json, false)
}

export function DiscardCompanyMemoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DiscardCompanyMemoResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateCompanyMemoResponseDataFromJSON(json['data'])
  }
}

export function DiscardCompanyMemoResponseToJSON(value?: DiscardCompanyMemoResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateCompanyMemoResponseDataToJSON(value.data)
  }
}
